$(function() {

  OT.createNS('OT.Search');

  OT.Search.recentlyBooked = function () {
    var injectorURL = 'https://www.opentable.com/injector/stats/v1/restaurants/';
    $.getJSON(injectorURL + OTSearchData.Results.RestaurantIds.toString() + '/reservations', function(data) {
        var bookings = data.reservations;
      $('.infinite-results-list > .content-section-list-row').each(function(index, el) {
        var $this = $(this);
        var rid = $this.data('rid');
        var bookedToday = OTSearchData.Experiments.sv2393 ? '<span class="bold-info-text">' + bookings[rid] + '</span>' : bookings[rid];
        var message = Resources.Strings.BookedToday.replace('{0}', bookedToday);
        if (bookedToday) {
          $this.find('.message-alerts').prepend('<div class="booking"><span class="tadpole"></span>' + message + '</div>');
        }
        var $parent = $this.closest('.infinite-results-list');
        if (bookedToday >= 5 && OTSearchData.Experiments.sv2137 && $parent.hasClass('exact-match')) {
          var title = Resources.Strings.ExactMatch_Booked.replace('{0}', bookedToday);
          $parent.find('.exact-title').text(title);
        }
      });
    });
  };

  OT.Search.recentlyBooked();
});
